<template>
    <solution-selector :solutionid="$root._data.solutionid" :storename="$root._data.storename == 'true' ? true : false" :validation="$root._data.validation" :errorMessage="$root._data.errorMessage"></solution-selector>
</template>

<script>
/* 
    All html properties are strings, so as such, we can't just check if storename is true/false, we need to check the string. 
    Then we convert it to a true boolean so the components don't need to worry about it.
*/
import SolutionSelector from './components/SolutionSelector';

export default {
    name: 'App',
    components: {
        SolutionSelector
    }
}
</script>
